// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./imgs/icon-star-active.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./imgs/icon-star-on.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Rating-module__root--wEwDY {
  box-sizing: border-box;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.Rating-module__is-block--wZPLU {
  width: 100%;
}

.Rating-module__title--Dxqzl {
  padding-bottom: 2px;
  color: #1a1a1a;
  font-size: 0.9375rem; /* 15px */
  font-weight: 700;
  line-height: normal;
  white-space: nowrap;
}

.Rating-module__stars--aEilx {
  display: flex;
  align-items: center;
}

.Rating-module__star--j83KP {
  display: block;
  padding: 0;
  border: 0;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: 28px 27px;
}

.Rating-module__size-medium--vBoE9 .Rating-module__stars--aEilx {
  gap: 10px;
}

.Rating-module__size-medium--vBoE9 .Rating-module__star--j83KP {
  width: 28px;
  height: 30px;
  flex: 0 0 28px;
  background-position: center top;
}

.Rating-module__star-active--pbKWL {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.Rating-module__star-inactive--apGTr {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.Rating-module__size-small--rZRN2 .Rating-module__stars--aEilx {
  width: 74px;
  height: 19px;
  gap: 1px;
}

.Rating-module__size-small--rZRN2 .Rating-module__star--j83KP {
  width: 14px;
  height: 19px;
  flex-basis: 14px;
  background-size: 14px 13.5px;
}

.Rating-module__description--DvUCD {
  padding-bottom: 1px;
  color: #a05a27;
  font-size: 0.8125rem; /* 13px */
  font-weight: 700;
  line-height: normal;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Rating/Rating.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB,EAAE,SAAS;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,SAAS;EACT,6BAA6B;EAC7B,yDAAoD;EACpD,2BAA2B;EAC3B,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,yDAAgD;AAClD;;AAEA;EACE,yDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB,EAAE,SAAS;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":[".root {\n  box-sizing: border-box;\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n}\n\n.is-block {\n  width: 100%;\n}\n\n.title {\n  padding-bottom: 2px;\n  color: #1a1a1a;\n  font-size: 0.9375rem; /* 15px */\n  font-weight: 700;\n  line-height: normal;\n  white-space: nowrap;\n}\n\n.stars {\n  display: flex;\n  align-items: center;\n}\n\n.star {\n  display: block;\n  padding: 0;\n  border: 0;\n  background-color: transparent;\n  background-image: url('./imgs/icon-star-active.svg');\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 28px 27px;\n}\n\n.size-medium .stars {\n  gap: 10px;\n}\n\n.size-medium .star {\n  width: 28px;\n  height: 30px;\n  flex: 0 0 28px;\n  background-position: center top;\n}\n\n.star-active {\n  background-image: url('./imgs/icon-star-on.svg');\n}\n\n.star-inactive {\n  background-image: url('./imgs/icon-star-active.svg');\n}\n\n.size-small .stars {\n  width: 74px;\n  height: 19px;\n  gap: 1px;\n}\n\n.size-small .star {\n  width: 14px;\n  height: 19px;\n  flex-basis: 14px;\n  background-size: 14px 13.5px;\n}\n\n.description {\n  padding-bottom: 1px;\n  color: #a05a27;\n  font-size: 0.8125rem; /* 13px */\n  font-weight: 700;\n  line-height: normal;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Rating-module__root--wEwDY`,
	"is-block": `Rating-module__is-block--wZPLU`,
	"title": `Rating-module__title--Dxqzl`,
	"stars": `Rating-module__stars--aEilx`,
	"star": `Rating-module__star--j83KP`,
	"size-medium": `Rating-module__size-medium--vBoE9`,
	"star-active": `Rating-module__star-active--pbKWL`,
	"star-inactive": `Rating-module__star-inactive--apGTr`,
	"size-small": `Rating-module__size-small--rZRN2`,
	"description": `Rating-module__description--DvUCD`
};
export default ___CSS_LOADER_EXPORT___;
